/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { OrganizationDto } from './organization-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { RunClubEventDistanceDto } from './run-club-event-distance-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { RunClubEventPaceGroupDto } from './run-club-event-pace-group-dto';

/**
 * 
 * @export
 * @interface RunClubEventDto
 */
export interface RunClubEventDto {
    /**
     * Event ID
     * @type {string}
     * @memberof RunClubEventDto
     */
    'id': string;
    /**
     * Title
     * @type {string}
     * @memberof RunClubEventDto
     */
    'title': string;
    /**
     * Description
     * @type {string}
     * @memberof RunClubEventDto
     */
    'description'?: string;
    /**
     * Cover photo URL
     * @type {string}
     * @memberof RunClubEventDto
     */
    'coverPhotoUrl': string;
    /**
     * Image URLs
     * @type {Array<string>}
     * @memberof RunClubEventDto
     */
    'imageUrls': Array<string>;
    /**
     * Assembly time (UTC)
     * @type {string}
     * @memberof RunClubEventDto
     */
    'assemblyAt': string;
    /**
     * Start time (UTC)
     * @type {string}
     * @memberof RunClubEventDto
     */
    'startAt': string;
    /**
     * End time (UTC)
     * @type {object}
     * @memberof RunClubEventDto
     */
    'endAt'?: object;
    /**
     * Timezone
     * @type {string}
     * @memberof RunClubEventDto
     */
    'timezone': string;
    /**
     * Visibility
     * @type {string}
     * @memberof RunClubEventDto
     */
    'visibility': RunClubEventDtoVisibilityEnum;
    /**
     * Status
     * @type {string}
     * @memberof RunClubEventDto
     */
    'status': RunClubEventDtoStatusEnum;
    /**
     * Fee amount
     * @type {object}
     * @memberof RunClubEventDto
     */
    'feeAmount'?: object;
    /**
     * Country code
     * @type {object}
     * @memberof RunClubEventDto
     */
    'countryCode'?: object;
    /**
     * Country name
     * @type {object}
     * @memberof RunClubEventDto
     */
    'countryName'?: object;
    /**
     * Province code
     * @type {object}
     * @memberof RunClubEventDto
     */
    'provinceCode'?: object;
    /**
     * Province name
     * @type {object}
     * @memberof RunClubEventDto
     */
    'provinceName'?: object;
    /**
     * City code
     * @type {object}
     * @memberof RunClubEventDto
     */
    'cityCode'?: object;
    /**
     * City name
     * @type {object}
     * @memberof RunClubEventDto
     */
    'cityName'?: object;
    /**
     * Barangay code
     * @type {object}
     * @memberof RunClubEventDto
     */
    'barangayCode'?: object;
    /**
     * Barangay name
     * @type {object}
     * @memberof RunClubEventDto
     */
    'barangayName'?: object;
    /**
     * Postal code
     * @type {object}
     * @memberof RunClubEventDto
     */
    'postalCode'?: object;
    /**
     * Street
     * @type {object}
     * @memberof RunClubEventDto
     */
    'street'?: object;
    /**
     * Landmark
     * @type {object}
     * @memberof RunClubEventDto
     */
    'landmark'?: object;
    /**
     * Distances
     * @type {Array<RunClubEventDistanceDto>}
     * @memberof RunClubEventDto
     */
    'distances': Array<RunClubEventDistanceDto>;
    /**
     * Pace groups
     * @type {Array<RunClubEventPaceGroupDto>}
     * @memberof RunClubEventDto
     */
    'paceGroups': Array<RunClubEventPaceGroupDto>;
    /**
     * Organizer
     * @type {OrganizationDto}
     * @memberof RunClubEventDto
     */
    'organizer': OrganizationDto;
}

export const RunClubEventDtoVisibilityEnum = {
    Public: 'public',
    Unlisted: 'unlisted',
    Private: 'private'
} as const;

export type RunClubEventDtoVisibilityEnum = typeof RunClubEventDtoVisibilityEnum[keyof typeof RunClubEventDtoVisibilityEnum];
export const RunClubEventDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Cancelled: 'cancelled'
} as const;

export type RunClubEventDtoStatusEnum = typeof RunClubEventDtoStatusEnum[keyof typeof RunClubEventDtoStatusEnum];


